import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "internal-navigation" }
const _hoisted_2 = { class: "internal-navigation__links-section" }
const _hoisted_3 = { class: "internal-navigation__links internal-navigation__links--primary" }
const _hoisted_4 = { class: "internal-navigation__links internal-navigation__links--secondary" }

import type { PropType } from 'vue';
import { useRoute } from 'vue-router';

import { accountService } from '@exchange/libs/account/service/src';
import ProfileUserSection from '@exchange/libs/account/ui/src/libs/ProfileUserSection.vue';

import type { NavigationLink } from './app-header/useNavigationLink';


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalNavigation',
  props: {
  links: { type: Object as PropType<{ primary: Array<NavigationLink>; secondary: Array<NavigationLink> }>, required: true },
},
  setup(__props) {



const route = useRoute();

const { userName, userEmail, accountIdHolder } = accountService;

const isPrimaryLinkActive = (link: NavigationLink) => {
  if (!route.name || typeof route.name !== 'string') {
    return false;
  }

  const ok = route.name === link.route?.name;
  const getMainName = (name?: string) => name?.split('.')[0] || '';
  const alsoOk = getMainName(route.name) === getMainName(link.route?.name);

  return ok || alsoOk;
};

return (_ctx: any,_cache: any) => {
  const _component_x_list_item = _resolveComponent("x-list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProfileUserSection, {
      "with-secondary-info": true,
      "user-email": _unref(userEmail),
      "account-holder-id": _unref(accountIdHolder),
      "user-name": _unref(userName)
    }, null, 8, ["user-email", "account-holder-id", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links.primary, (link) => {
          return (_openBlock(), _createBlock(_component_x_list_item, {
            key: link.id,
            active: isPrimaryLinkActive(link),
            "left-icon-inherit-stroke": true,
            "left-icon-name": link.icon,
            "left-icon-warning": link.iconWithWarning,
            "left-icon-info": link.iconWithInfo,
            title: link.title,
            "router-link": link.route
          }, null, 8, ["active", "left-icon-name", "left-icon-warning", "left-icon-info", "title", "router-link"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links.secondary, (link) => {
          return (_openBlock(), _createBlock(_component_x_list_item, {
            key: link.id,
            "left-icon-inherit-stroke": true,
            "left-icon-name": link.icon,
            title: link.title,
            href: link.url
          }, null, 8, ["left-icon-name", "title", "href"]))
        }), 128))
      ])
    ])
  ]))
}
}

})